import { PagedMultiSelectField, defaultFeedbackService, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";

interface Props {
	name: string;
	label: string;
	required?: boolean;
	clearable?: boolean;
}

export const FeedbackMultiSelectField: FC<Props> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={laravelServiceSelectFetchConfig(defaultFeedbackService)} />;
};
